import Grid2 from '@shared/components/Grid2';
import { H2 } from '@shared/components/Heading';
import Paragraph from '@shared/components/Paragraph';
import { FC, memo } from 'react';

import { SectionDark1, SectionDark3 } from '../../components/ColoredSection';

const Methode: FC = () => (
  <>
    <SectionDark1>
      <H2>Mit Methode zur Meisterschaft</H2>
      <Grid2 spacing={{ md: '2rem', xs: '0' }}>
        <Grid2.Item>
          <Paragraph>
            Viele Systema-Stile und -Schulen arbeiten ohne feste Graduierungen und Lehrpläne, was
            zunächst offen und kreativ erscheinen mag. Allerdings geht diese Offenheit oft auf
            Kosten der Qualität, da Wissen nicht ausreichend wiederholt, gefestigt und überprüft
            wird. Dies führt häufig dazu, dass es neben dem Gründer nur wenige oder keine weiteren
            Meister gibt.
          </Paragraph>
        </Grid2.Item>
        <Grid2.Item>
          <Paragraph>
            Das Systema „Solovev Defense“ von Falko Zander verfolgt deshalb einen anderen Ansatz:
            Als einzige Systema-Schule weltweit unterrichten wir anhand eines strukturierten
            Prüfungsprogramm. Dieses garantiert einen klaren Weg zur Meisterschaft. Verständliche
            Theorie in Verbindung mit klaren Lernschritten sorgen für Deinen Erfolg.
          </Paragraph>
        </Grid2.Item>
      </Grid2>
    </SectionDark1>

    <SectionDark3>
      <H2>Universum des Wissens</H2>

      <Paragraph>
        Viele Wege führen nach Rom. Wenn es Dir aber wichtig ist, auch wirklich anzukommen, dann
        solltest Du Dich für einen sicheren Weg entscheiden.
      </Paragraph>

      <Paragraph>
        Das Prüfungsprogramm von Falko Zander ist so ein sicherer Weg. Es stellt sicher, dass Du
        Schritt für Schritt das notwendige Fundament erlernst. Alle wichtigen Details werden so
        lange wiederholt und eingeprägt, bis Du sie hinreichend gut beherrscht.
      </Paragraph>
    </SectionDark3>
  </>
);

export default memo(Methode);
